// extracted by mini-css-extract-plugin
export default {"fullScreenButton":"fullScreenButton-RHsOUF1Y"};